import {
  AuthMissing,
  cognitoUserToAuthState,
  getCognitoUser,
  logoutCognitoUser,
} from "shared/store/auth/api";
import { authSetAction } from "shared/store/auth";
import { captureException } from "clients/helpers/logger";
import { ApplicationState } from "../index";
import { AnyAction, Store } from "redux";

/**
 * This should actually be within a saga, but the base is shared with admin so
 *  we would have to do some weird inheritance things,
 *   we do a simple call instead
 * @param store
 */
export async function initClientUser(
  store: Store<ApplicationState, AnyAction>
) {
  try {
    const cognitoUser = await getCognitoUser();
    const authState = await cognitoUserToAuthState(cognitoUser);
    store.dispatch(authSetAction({ ...authState, isLoaded: true }));
    return Promise.resolve();
  } catch (e) {
    if (!(e instanceof AuthMissing)) {
      captureException(e, {
        category: "temp-user",
        message: "Could not load user.",
      });
      // User Auth bad, clear to avoid retrying repeatedly.
      await logoutCognitoUser();
      store.dispatch(
        authSetAction({
          isLoaded: true,
          isLoggedIn: false,
          user: undefined,
        })
      );
      return;
    }
    // no user logged in, or error. loading auth is complete
    store.dispatch(
      authSetAction({
        isLoaded: true,
        isLoggedIn: false,
        user: undefined,
      })
    );
  }
}

export function getTimeZone(): string | null {
  let timeZone = null;
  try {
    timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (e) {
    captureException(e, { category: "braintree.timezone" });
  }
  return timeZone;
}
